
import { Component, Inject, Input, Output }  from 'ng-metadata/core';
import {LoginService} from '../security/login/login.service';
import {StorageUtil} from '../infra/storageUtil.service';
import {LoginIframeService} from './loginIframe.service';
import {SilentLoginService} from "./silentLogin/silentLogin.service";

@Component({
	selector: 'prm-login-iframe',
	templateUrl: 'components/primoExplore/login-iframe.html',
})

export class LoginIframe{

    private tryAgain : boolean;
    private url : string;
	constructor(  private loginService: LoginService ,private storageUtil: StorageUtil, private loginIframeService:LoginIframeService, private silentLoginService: SilentLoginService ) {
	    this.tryAgain = this.loginIframeService.getTryAgain() || this.loginIframeService.trySilentLogin();
	    if (!this.tryAgain || !this.getUrl()){
	        this.silentLoginService.silentLoginEnd(); //signal that silent login is ended (even though it never started)
        }

	}


	private getUrl(){
	    this.url = this.loginIframeService.getUrl();
	    return this.url;
    }

    public getLoginUrls(){
	    return this.loginIframeService.getLoginUrls();
    }

    public isSilentIframeEnabled(){
        console.log('try silent login: '+this.tryAgain);
        return this.tryAgain;

    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/loginIframe.directive.ts